<template>
  <div class="child-div">
    <div class="list">
      <div class="addList">
        <span><span class="red">*</span>社区(村):</span>
        <van-field placeholder="请选择社区(村)" v-model="dataForm.OrgName" readonly @click="orgShow = true" />
        <van-popup v-model="orgShow" round position="bottom">
          <van-cascader
            v-model="dataForm.OrgName"
            title="请选择社区(村)"
            :options="organList"
            @close="orgShow = false"
            @finish="onFinish"
            :field-names="{
              text: 'OrganName',
              value: 'OrganCode',
              children: 'Children',
            }"
          />
        </van-popup>
      </div>
      <div class="addList">
        <span><span class="red">*</span>姓名:</span>
        <van-field placeholder="请输入老人姓名" v-model="dataForm.Name" />
      </div>
      <div class="addList">
        <span><span class="red">*</span>身份证号:</span>
        <van-field placeholder="请输入身份证号" v-model="dataForm.IDCard" @blur="IdNum(dataForm.IDCard)" />
      </div>
      <div class="addList">
        <span><span class="red"> </span>老人电话:</span>
        <van-field placeholder="请输入老人电话" v-model="dataForm.Tel" />
      </div>
      <div class="addList">
        <span><span class="red"> </span>性别:</span>
        <van-radio-group v-model="dataForm.Sex" direction="horizontal" style="width: 85%;">
          <van-radio :name="1">男</van-radio>
          <van-radio :name="2">女</van-radio>
        </van-radio-group>
      </div>
      <div class="addList">
        <span><span class="red"> </span>出生日期:</span>
        <van-field
          v-model="dataForm.Birthday"
          name="Birthday"
          @click="recumenFend = true"
          readonly="readonly"
          placeholder="请选择出生日期"
        />
        <van-popup v-model="recumenFend" position="bottom" get-container="body">
          <van-datetime-picker
            v-model="currentDate"
            show-toolbar
            type="date"
            title="请选择出生日期"
            :min-date="minDate"
            :max-date="maxDate"
            @cancel="recumenFend = false"
            @confirm="onrecumenFend"
          >
          </van-datetime-picker>
        </van-popup>
      </div>
      <div class="addList">
        <span><span class="red">*</span>联系人:</span>
        <van-field placeholder="请输入联系人" v-model="dataForm.TouchMan" />
      </div>
      <div class="addList">
        <span><span class="red">*</span>联系人电话:</span>
        <van-field placeholder="请输入联系人电话" v-model="dataForm.TouchTel" />
      </div>
      <div class="addList">
        <span><span class="red"> </span>居住地址:</span>
        <van-field placeholder="请输入居住地址" v-model="dataForm.Address" />
      </div>
      <div class="addList">
        <span><span class="red"> </span>户籍地址:</span>
        <van-field placeholder="请输入户籍地址" v-model="dataForm.RegAddr" />
      </div>
      <div class="addList">
        <span><span class="red"> </span>婚姻状况:</span>
        <van-field placeholder="请选择婚姻状况" readonly v-model="dataForm.MarriageDesc" @click="hunyinPicker = true" />
        <van-popup v-model="hunyinPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="MarriageList"
            value-key="name"
            @confirm="hunyinQr"
            @cancel="hunyinPicker = false"
          />
        </van-popup>
      </div>
      <div class="addList">
        <span><span class="red"> </span>身体状况:</span>
        <van-field
          placeholder="请选择身体状况"
          readonly
          v-model="dataForm.BodyStateDesc"
          @click="shentiPicker = true"
        />
        <van-popup v-model="shentiPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="BodyStatusList"
            value-key="name"
            @confirm="shentiQr"
            @cancel="shentiPicker = false"
          />
        </van-popup>
      </div>
      <div class="addList">
        <span><span class="red"> </span>居住状况:</span>
        <van-field placeholder="请选择居住状况" readonly v-model="dataForm.LiveStateDesc" @click="livePicker = true" />
        <van-popup v-model="livePicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="liveStateData"
            value-key="name"
            @confirm="liveQr"
            @cancel="livePicker = false"
          />
        </van-popup>
      </div>
      <div class="addList">
        <span><span class="red">*</span>人员类别:</span>
        <van-checkbox-group v-model="dataForm.OMSort" style="width: 85%;" direction="horizontal">
          <van-checkbox
            :name="item.id"
            shape="square"
            v-for="(item, index) in OMSortList"
            :key="index + 'bb'"
            style="margin: 5px;"
            >{{ item.name }}</van-checkbox
          >
        </van-checkbox-group>
      </div>
      <div class="addList">
        <span><span class="red">*</span>基础疾病:</span>
        <van-checkbox-group v-model="dataForm.Diseases" style="width: 85%;" direction="horizontal">
          <van-checkbox
            :name="item.id"
            shape="square"
            v-for="(item, index) in diseasesData"
            :key="index + 'cc'"
            style="margin: 5px;"
            >{{ item.name }}</van-checkbox
          >
        </van-checkbox-group>
      </div>
      <div class="addList">
        <span><span class="red">*</span>养老需求:</span>
        <van-checkbox-group v-model="dataForm.Demand" style="width: 85%;" direction="horizontal">
          <van-checkbox
            :name="item.id"
            shape="square"
            v-for="(item, index) in SerKindList"
            :key="index + 'dd'"
            style="margin: 5px;"
            >{{ item.name }}</van-checkbox
          >
        </van-checkbox-group>
      </div>
      <div class="addList">
        <span><span class="red"> </span>状态:</span>
        <van-radio-group v-model="dataForm.Status" direction="horizontal" style="width: 85%;">
          <van-radio :name="1">有效</van-radio>
          <van-radio :name="2">无效</van-radio>
        </van-radio-group>
      </div>
      <div class="addList">
        <span><span class="red"> </span>备注:</span>
        <van-field placeholder="请输入备注" v-model="dataForm.Remark" />
      </div>
    </div>
    <van-button class="button" @click="submit()">提 交</van-button>
  </div>
</template>

<script>
import { WeGetOrganTree, GetOldManDetail, saveOldMan } from '@/api/Organ'
import { getwgToken, setwgToken } from '@/utils/auth'
import wx from 'weixin-js-sdk'
import { Dialog } from 'vant'
import Vue from 'vue'
import { Toast } from 'vant'
Vue.use(Toast)
export default {
  data() {
    return {
      OMId: '',
      hunyinPicker: false,
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(2050, 10, 1),

      currentDate: new Date(2021, 0, 17),
      orgShow: false,
      dataForm: {
        OrgName: '',
        OMSort: [],
        Diseases: [],
        Status: 1,
      },
      organList: [],
      recumenFend: false,
      shentiPicker: false,
      livePicker: false,
      MarriageList: [
        {
          name: '未婚',
          id: 1,
        },
        {
          name: '已婚',
          id: 2,
        },
        {
          name: '丧偶',
          id: 3,
        },
        {
          name: '离婚',
          id: 4,
        },
      ],
      BodyStatusList: [
        {
          name: '自理',
          id: 1,
        },
        {
          name: '半自理',
          id: 2,
        },
        {
          name: '失能',
          id: 3,
        },
      ],
      liveStateData: [
        {
          name: '独居',
          id: 1,
        },
        {
          name: '与配偶、伴侣居住',
          id: 2,
        },
        {
          name: '与子女居住',
          id: 3,
        },
        {
          name: '与父母居住',
          id: 4,
        },
        {
          name: '与其他亲属居住',
          id: 5,
        },
        {
          name: '与非亲属关系人居',
          id: 6,
        },
        {
          name: '养老机构居住',
          id: 7,
        },
      ],
      OMSortList: [
        {
          name: '特困对象',
          id: '1',
        },
        {
          name: '低保老人',
          id: '2',
        },
        {
          name: '农村留守老人',
          id: '3',
        },
        {
          name: '城市空巢老人',
          id: '4',
        },
        // {
        //   name: "高龄老人",
        //   id: "5"
        // },
        {
          name: '残疾老人',
          id: '6',
        },
        {
          name: '失能老人',
          id: '7',
        },
        {
          name: '半失能老人',
          id: '8',
        },
        {
          name: '计划生育特殊家庭',
          id: '9',
        },
        {
          name: '三无老人',
          id: '10',
        },
        {
          name: '退休职工',
          id: '11',
        },
        {
          name: '退休干部',
          id: '12',
        },
        {
          name: '居民',
          id: '13',
        },
        {
          name: '三无下放人员',
          id: '14',
        },
        {
          name: '供养人员',
          id: '15',
        },
        // {
        //   name: "退休军人",
        //   id: "16",
        // },
        {
          name: '军烈属',
          id: '17',
        },
        {
          name: '退役军人',
          id: '19',
        },
        // {
        //   name: "退休/离休军人（干部）",
        //   id: "19",
        // },
        {
          name: '其他',
          id: '18',
        },
      ],
      diseasesData: [
        {
          name: '高血压',
          id: '1',
        },
        {
          name: '糖尿病',
          id: '2',
        },
        {
          name: '冠心病',
          id: '3',
        },
        {
          name: '慢性阻塞性肺疾病',
          id: '4',
        },
        {
          name: '恶性肿瘤',
          id: '5',
        },
        {
          name: '脑卒中',
          id: '6',
        },
        {
          name: '脑血管疾病（含中风）',
          id: '7',
        },
        {
          name: '重性精神疾病',
          id: '8',
        },
        {
          name: '结核病',
          id: '9',
        },
        {
          name: '肺炎',
          id: '10',
        },
        {
          name: '其他法定传染病',
          id: '11',
        },
        {
          name: '阿尔兹海默症',
          id: '12',
        },
        {
          name: '职业病',
          id: '13',
        },
        {
          name: '心脏病',
          id: '14',
        },
        {
          name: '帕金森氏综合症',
          id: '15',
        },
        {
          name: '关节炎类风湿性关节炎',
          id: '16',
        },
        {
          name: '甲亢',
          id: '17',
        },
        {
          name: '肾病综合症',
          id: '18',
        },
        {
          name: '肝硬化',
          id: '19',
        },
        {
          name: '其他',
          id: '20',
        },
      ],
      SerKindList: [
        {
          id: 1,
          name: '助餐',
        },
        {
          id: 2,
          name: '助洁',
        },
        {
          id: 3,
          name: '助行',
        },
        {
          id: 4,
          name: '助浴',
        },
        {
          id: 5,
          name: '助医',
        },
        {
          id: 6,
          name: '康复',
        },
        {
          id: 7,
          name: '巡访关爱',
        },
        {
          id: 8,
          name: '辅助租赁',
        },
        {
          id: 9,
          name: '自我照料',
        },
        {
          id: 10,
          name: '配偶照顾',
        },
        {
          id: 11,
          name: '子女照顾',
        },
        {
          id: 12,
          name: '自购家政服务',
        },
        {
          id: 13,
          name: '入住养老机构',
        },
        {
          id: 99,
          name: '其他',
        },
      ],
    }
  },
  created() {
    this.getOrganList()
    console.log(this.$route.params)
    // 详情
    if (this.$route.params.add == 1) {
      this.OMId = this.$route.params.id
      this.oldManDetail()
    }
  },
  methods: {
    // 点击社区
    onFinish(val) {
      // console.log(val)
      this.fieldValue = val.selectedOptions.map((option) => option.OrganName).join('/')
      this.dataForm.OrgName = this.fieldValue
      this.dataForm.OrgCode = val.value
      this.orgShow = false
    },
    // 获取社区村
    getOrganList() {
      WeGetOrganTree({ level: 4, kind: 1 }).then((res) => {
        this.organList = res.data.data
      })
    },
    //出生日期 确认
    onrecumenFend(val) {
      this.dataForm.Birthday = this.dateformat(val)
      this.recumenFend = false
    },
    // 婚姻状况确认
    hunyinQr(val) {
      this.dataForm.Marriage = val.id
      this.dataForm.MarriageDesc = val.name
      this.hunyinPicker = false
    },
    // 选中身体状况
    shentiQr(val) {
      this.dataForm.BodyState = val.id
      this.dataForm.BodyStateDesc = val.name
      this.shentiPicker = false
    },
    // 选中居住状况
    liveQr(val) {
      this.dataForm.LiveState = val.id
      this.dataForm.LiveStateDesc = val.name
      this.livePicker = false
    },
    oldManDetail() {
      GetOldManDetail({ omId: this.OMId }).then((res) => {
        console.log(res)
        if (res.data.code == 0) {
          this.dataForm = res.data.data
          if (res.data.data.OMSort != null && this.dataForm.OMSort != '') {
            this.dataForm.OMSort = res.data.data.OMSort.split(',')
          } else {
            this.dataForm.OMSort = []
          }
          if (this.dataForm.Diseases != null && this.dataForm.Diseases != '') {
            this.dataForm.Diseases = this.dataForm.Diseases.split(',')
          } else {
            this.dataForm.Diseases = []
          }

          if (this.dataForm.Demand != null && this.dataForm.Demand != '') {
            this.dataForm.Demand = this.dataForm.Demand.split(',')
          } else {
            this.dataForm.Demand = []
          }
          if (this.dataForm.Marriage != null && this.dataForm.Marriage != '') {
            this.marriage(this.dataForm.Marriage)
          }
          if (this.dataForm.BodyState != null && this.dataForm.BodyState != '') {
            this.bodyState(this.dataForm.BodyState)
          }
          if (this.dataForm.LiveState != null && this.dataForm.LiveState != '') {
            this.liveState(this.dataForm.LiveState)
          }
          console.log(this.dataForm)
        } else if (res.data.code == 401) {
          Toast('用户未登录请重新登录')
          if (window.__wxjs_environment === 'miniprogram') {
            window.wx.miniProgram.redirectTo({
              url: 'pages/admin/adminLogin/adminLogin',
            })
          } else {
            alert('请在小程序中打开')
          }
        } else {
          Toast(res.data.msg)
        }
      })
    },
    // 婚姻状况
    marriage(val) {
      this.MarriageList.forEach((item) => {
        if (val == item.id) {
          this.dataForm.MarriageDesc = item.name
        }
      })
    },
    // 身体状况
    bodyState(val) {
      this.BodyStatusList.forEach((item) => {
        if (val == item.id) {
          this.dataForm.BodyStateDesc = item.name
        }
      })
    },
    // 居住状况
    liveState(val) {
      this.liveStateData.forEach((item) => {
        if (val == item.id) {
          this.dataForm.LiveStateDesc = item.name
        }
      })
    },
    // 提交
    submit() {
      if (this.dataForm.OrgName == '' || this.dataForm.OrgName == null || this.dataForm.OrgName == undefined) {
        Toast.fail('请选择社区(村)')
        return
      }
      if (this.dataForm.Name == '' || this.dataForm.Name == null || this.dataForm.Name == undefined) {
        Toast.fail('请输入老人姓名')
        return
      }
      if (this.dataForm.IDCard == '' || this.dataForm.IDCard == null || this.dataForm.IDCard == undefined) {
        Toast.fail('请输入身份证号')
        return
      }
      if (this.dataForm.TouchMan == '' || this.dataForm.TouchMan == null || this.dataForm.TouchMan == undefined) {
        Toast.fail('请输入联系人')
        return
      }
      if (this.dataForm.TouchTel == '' || this.dataForm.TouchTel == null || this.dataForm.TouchTel == undefined) {
        Toast.fail('请输入联系人电话')
        return
      }
      if (this.dataForm.OMSort.length == 0) {
        Toast.fail('请选择人员类型')
        return
      }
      if (this.dataForm.Diseases.length == 0) {
        Toast.fail('请选择基础疾病')
        return
      }
      if (this.dataForm.Demand.length == 0) {
        Toast.fail('请选择养老需求')
        return
      }
      let params = Object.assign({}, this.dataForm)
      params.OMSort = this.dataForm.OMSort + ''
      params.Diseases = this.dataForm.Diseases + ''
      params.Demand = this.dataForm.Demand + ''
      // console.log(params)
      // return
      saveOldMan(params).then((res) => {
        if (res.data.code == 0) {
          Toast.success('保存成功')
          this.$router.go(-1)
        } else {
          Toast.fail(res.data.msg)
        }
      })
    },
    // 时间格式化事件 yy-mm-dd
    dateformat(val) {
      let year = val.getFullYear()
      let month = val.getMonth() + 1
      let day = val.getDate()
      if (month >= 1 && month <= 9) {
        month = `0${month}`
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`
      }
      return `${year}-${month}-${day}`
    },

    // 获取身份证
    IdNum(value) {
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      if (value.length > 0) {
        if (reg.test(value)) {
          this.go(value.length)
        } else {
          Toast.fail('身份证号码不正确')
        }
      }
    },
    go(val) {
      var iden = this.dataForm.IDCard == '' ? this.dataForm.IDCard : this.dataForm.IDCard
      // var iden = this.dataForms.IdNumber;
      console.log(iden)
      var id = iden.substring(0, 6)
      // this.dataForm.NativeCantonCode = id
      // console.log(this.dataForm.NativeCantonCode)
      var sex = null
      var birth = null
      var myDate = new Date()
      var month = myDate.getMonth() + 1
      var day = myDate.getDate()
      var age = 0
      if (val === 18) {
        age = myDate.getFullYear() - iden.substring(6, 10) - 1
        sex = iden.substring(16, 17)
        birth = iden.substring(6, 10) + '-' + iden.substring(10, 12) + '-' + iden.substring(12, 14)
        if (iden.substring(10, 12) < month || (iden.substring(10, 12) == month && iden.substring(12, 14) <= day)) age++
      }
      if (val === 15) {
        age = myDate.getFullYear() - iden.substring(6, 8) - 1901
        sex = iden.substring(13, 14)
        birth = '19' + iden.substring(6, 8) + '-' + iden.substring(8, 10) + '-' + iden.substring(10, 12)
        if (iden.substring(8, 10) < month || (iden.substring(8, 10) == month && iden.substring(10, 12) <= day)) age++
      }
      if (sex % 2 == 0) {
        sex = 2
        this.dataForm.Sex = sex
        this.age = age
        this.dataForm.Birthday = birth
        this.currentDate = new Date(this.dataForm.Birthday)
      } else {
        sex = 1
        // this.hzlist.Sex = sex;
        this.dataForm.Sex = sex
        this.age = age
        this.dataForm.Birthday = birth
        this.currentDate = new Date(this.dataForm.Birthday)
      }
    },
  },
}
</script>
<style scoped>
.list {
  width: 94%;
  margin: 0px 3% 10px 3%;
  background: #fff;
  border-radius: 13px;
  padding: 10px 0px;
  box-shadow: 0px 0px 3px rgb(228, 226, 226);
}
.addList {
  display: flex;
  border-bottom: 1px solid #cccccc29;
  justify-content: center;
  padding: 5px 5px;
  margin: 0px 15px;
}
.addList span {
  width: 40%;
  font-size: 16px;
  padding: 10px 0px;
}
.red {
  color: red;
  margin-right: 2px;
}

/* 按钮 */
.button {
  width: 80%;
  height: 40px;
  line-height: 40px;
  margin: 10px 10%;
  background: #3296fa;
  color: #fff;
  border: 1px solid #3296fa;
  border-radius: 5px;
}
</style>
